import { PillTypes, Resources } from '../constants';

export default {
  [Resources[PillTypes.COMPANY_CODES]]: [],
  [Resources[PillTypes.BUSINESS_UNITS]]: [],
  [Resources[PillTypes.LEGAL_ENTITIES]]: [],
  [Resources[PillTypes.TAX_RATES]]: [],
  [Resources[PillTypes.BOOK_TO_TAX_DIFFERENCES]]: [],
  [Resources[PillTypes.OBLIGATIONS]]: [],
  [Resources[PillTypes.TAX_BOOKING_ENTITIES]]: [],
  [Resources[PillTypes.TLS_ACCOUNTS]]: [],
  [Resources[PillTypes.TAX_ACCOUNTING]]: [],
  [Resources[PillTypes.TAX_IBT_RANGES]]: [],
  [Resources[PillTypes.USERS]]: [],
  [Resources[PillTypes.SUBLEDGER_MAP]]: [],
  [Resources[PillTypes.CURRENCY]]: [],
  [Resources[PillTypes.CURRENCY_CONVERSION_RATES]]: [],
  loading: {
    [Resources[PillTypes.COMPANY_CODES]]: false,
    [Resources[PillTypes.BUSINESS_UNITS]]: false,
    [Resources[PillTypes.LEGAL_ENTITIES]]: false,
    [Resources[PillTypes.TAX_RATES]]: false,
    [Resources[PillTypes.BOOK_TO_TAX_DIFFERENCES]]: false,
    [Resources[PillTypes.OBLIGATIONS]]: false,
    [Resources[PillTypes.TAX_BOOKING_ENTITIES]]: false,
    [Resources[PillTypes.TLS_ACCOUNTS]]: false,
    [Resources[PillTypes.TAX_ACCOUNTING]]: false,
    [Resources[PillTypes.TAX_IBT_RANGES]]: false,
    [Resources[PillTypes.USERS]]: false,
    [Resources[PillTypes.SUBLEDGER_MAP]]: false,
    [Resources[PillTypes.CURRENCY]]: false,
    [Resources[PillTypes.CURRENCY_CONVERSION_RATES]]: false,
  },
};
